import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingNoSearchData = createSelector(
  [selectLandingState],
  ({ isNotSearchData }) => {
    return isNotSearchData
  }
)
